import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { RequireAdmin } from '@/auth/RequireAdmin';
import { TopBar } from '@/components/TopBar';
import { CalculatorPage } from '@/pages/CalculatorPage';
import { LoginPage } from '@/pages/LoginPage';
import { AdminRatesPage } from '@/pages/AdminRatesPage';
import { AdminUsersPage } from '@/pages/AdminUsersPage';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <TopBar />
        <main>
          <Routes>
            <Route path="/" element={<CalculatorPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin/rates"
              element={
                <RequireAdmin>
                  <AdminRatesPage />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/users"
              element={
                <RequireAdmin>
                  <AdminUsersPage />
                </RequireAdmin>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </BrowserRouter>
    </AuthProvider>
  );
}
